import type { Page, Post, Project } from '@/payload-types'

export function getCMSLinkHref({
  type,
  reference,
  url,
}: {
  type?: 'custom' | 'reference' | null
  reference?: {
    relationTo: 'pages' | 'posts' | 'projects'
    value: Page | Post | Project | string | number
  } | null
  url?: string | null
}): string | null | undefined {
  if (type === 'reference' && typeof reference?.value === 'object' && reference.value.slug) {
    if (reference?.relationTo === 'posts') {
      return `/blog/${reference.value.slug}`
    }
    if (reference?.relationTo === 'pages') {
      return `/${reference.value.slug}`
    }
    return `/${reference?.relationTo}/${reference?.value.slug}`
  }
  if (type === 'reference' && typeof reference?.value === 'string') {
    if (reference?.relationTo === 'posts') {
      return `/blog/${reference.value}`
    }
    if (reference?.relationTo === 'pages') {
      return `/${reference.value}`
    }
    return `/${reference?.relationTo}/${reference?.value}`
  }
  return url || ''
}

export function getCMSLinkHrefAndTabProps(props: {
  type?: 'custom' | 'reference' | null
  reference?: {
    relationTo: 'pages' | 'posts' | 'projects'
    value: Page | Post | Project | string | number
  } | null
  url?: string | null
  newTab?: boolean | null
  label?: string | null
}) {
  const { type, newTab, reference, url } = props
  const href = getCMSLinkHref({ type, reference, url })

  if (!href) return { href: '', newTabProps: {} }

  const newTabProps = newTab ? { rel: 'noopener noreferrer', target: '_blank' } : {}

  return {
    children: props.label,
    href: href || url || '',
    ...newTabProps,
  }
}
